import * as React from 'react';
import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CodeToggle,
  headingsPlugin,
  MDXEditor,
  toolbarPlugin,
  UndoRedo
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';
import { styled } from '../../../theme';
import { Btn, ButtonType, ButtonWidget } from '../../../widgets/buttons/ButtonWidget';
import { selectFile } from '@journeyapps-platform/ide-lib-reactor-utils';
import { useForceUpdate } from '../../../hooks/useForceUpdate';

export interface TicketReplyValue {
  attachments: File[];
  markdown: string;
}

export interface TicketReplyInputWidgetProps {
  className?: any;
  AdditionalButtons?: (Btn & { key: string })[];
  valueRef: React.RefObject<TicketReplyValue>;
}

export const TicketReplyInputWidget: React.FC<TicketReplyInputWidgetProps> = (props) => {
  let forceUpdate = useForceUpdate();
  return (
    <>
      <S.Container className={props.className}>
        <S.MDX
          markdown={''}
          onChange={(value) => {
            props.valueRef.current!.markdown = value;
          }}
          placeholder="Type reply here..."
          className="dark-theme dark-editor"
          autoFocus={true}
          plugins={[
            headingsPlugin(),
            toolbarPlugin({
              toolbarClassName: 'toolbar',
              toolbarContents: () => (
                <>
                  <UndoRedo />
                  <BlockTypeSelect />
                  <BoldItalicUnderlineToggles />
                  <CodeToggle />
                </>
              )
            })
          ]}
        />
        <S.Buttons>
          <ButtonWidget
            type={ButtonType.SECONDARY}
            label="Attach"
            icon="paperclip"
            action={async () => {
              let file = await selectFile();
              if (file) {
                props.valueRef.current!.attachments = [...(props.valueRef.current?.attachments || []), file];
                forceUpdate();
              }
            }}
          />
          {(props.AdditionalButtons || []).map((btn) => {
            return <ButtonWidget {...btn} />;
          })}
        </S.Buttons>
        {(props.valueRef.current!.attachments || []).length > 0 ? (
          <S.Attachments>
            {props.valueRef.current!.attachments.map((f) => {
              return (
                <S.File key={f.name}>
                  <S.FileName>{f.name}</S.FileName>
                  <ButtonWidget
                    type={ButtonType.TERTIARY}
                    icon="close"
                    action={() => {
                      props.valueRef.current!.attachments.splice(props.valueRef.current!.attachments.indexOf(f), 1);
                      forceUpdate();
                    }}
                  />
                </S.File>
              );
            })}
          </S.Attachments>
        ) : null}
      </S.Container>
    </>
  );
};
namespace S {
  export const Container = styled.div`
    overflow: auto;
    position: relative;
    display: flex;
    flex-direction: column;

    .toolbar {
      background: transparent;
      color: var(--baseText);
      --basePageBg: black;
      position: relative;
      z-index: 0;
    }
  `;

  export const FileName = styled.div`
    padding-left: 5px;
    padding-right: 5px;
  `;

  export const File = styled.div`
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    color: white;
    padding: 2px;
    display: flex;
    align-items: center;
  `;

  export const Attachments = styled.div`
    display: flex;
    column-gap: 5px;
    row-gap: 5px;
    margin-top: 10px;
    flex-grow: 0;
    flex-shrink: 0;
  `;

  export const MDX = styled(MDXEditor)`
    flex-grow: 1;
  `;

  export const Buttons = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    column-gap: 5px;
    display: flex;
    align-items: center;
    z-index: 0;
  `;
}
